module.exports = __webpack_public_path__ + "static/media/about-us-small-banner.8af276ab.svg";